function userListElement() {

    var show = $('._js-user-list-show'),
        hide = $('._js-user-list-hide');

    //$('._js-user-list-details').hide();

    show.on('click', function(){
        var element = $(this).parents('.user-list-element'),
            details = element.find('._js-user-list-details'),
            svg =  $(this).find('._arr-rounded-corner');

        if ( !element.hasClass('_active') ) {
            element.stop().addClass('_active');
            details.stop().slideDown(300);
            svg.addClass('_arr-rounded-corner_open');
        }
    });

    hide.on('click', function(){
        var element = $(this).parents('.user-list-element'),
            details = element.find('._js-user-list-details'),
            svg =  $(this).parents('.user-list-element').find('._arr-rounded-corner');

        if ( element.hasClass('_active') ) {
            element.stop().removeClass('_active');
            details.stop().slideUp(300);
            svg.removeClass('_arr-rounded-corner_open');
        }
    });
}